export enum ResultSetActionTypes {
    API_RESPONSE_SUCCESS = '@@resultSet/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@resultSet/API_RESPONSE_ERROR',

    ADD_RESULT_SET = '@@resultSet/ADD_RESULT_SET',
    EDIT_RESULT_SET = '@@resultSet/EDIT_RESULT_SET',
    GET_RESULT_SETS = '@@resultSet/GET_RESULT_SETS',
    GET_RESULT_SET = '@@resultSet/GET_RESULT_SET',
    RESET = '@@resultSet/RESET',
    RESET_SUCCESS = '@@resultSet/RESET_SUCCESS',
    RESET_ERROR = '@@resultSet/RESET_ERROR',
}
